import * as React from 'react';

import './style.scss';

type Props = {
  icon: React.ReactNode,
  label: string,
  title: string,
  subtitle: string,
  link?: React.ReactNode,
};

const InfoBlock: React.FC<Props> = (props) => {
  const {
    icon,
    label,
    title,
    subtitle,
    link,
  } = props;

  return (
    <div className="InfoBlock">
      <div className="InfoBlock__icon">
        {icon}
      </div>
      <div className="InfoBlock__content">
        <div className="InfoBlock__label">{label}</div>
        <div className="InfoBlock__title m-0 h3">{title}</div>
        <div className="InfoBlock__subtitle m-0 h4">{subtitle}</div>
        {link}
      </div>
    </div>
  );
};

export default InfoBlock;
